import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-uiform-preview',
  templateUrl: './uiform-preview.component.html',
  styleUrls: ['./uiform-preview.component.scss'],
})
export class UiformPreviewComponent implements OnInit {
  @Input() fields: any;
  @Input() groupLabels: any;
  @Input() usecaseAttributes: any;
  @Input() buttons: any;
  @Input() columns: any;

  ngOnInit(): void {}

  getAttributeById(fieldId: number) {
    return this.usecaseAttributes.find(
      (attr: any) => attr.id === fieldId && attr['system'] != 1,
    );
  }

  getColum(field: any) {
    if (field['colsize']) {
      return 12 / field['colsize'];
    }
    return 12;
  }

  getDefaultColums(field: any) {
    let size = 12;
    if (this.columns) {
      size = 12 / this.columns;
    }
    return 12;
  }

  getColums(field: any) {
    let size = 12;
    if (this.columns) {
      size = 12 / this.columns;
    }
    if (field['colsize'] && field['colsize'] > 0) {
      let tempSize = size * field['colsize'];
      if (tempSize <= 12) {
        return tempSize;
      } else {
        return 12;
      }
    }
    return size;
  }

  getRows(field: any) {
    if (field['rowsize'] && field['rowsize'] > 1 && field['rowsize'] < 4) {
      return 'row-size-' + field['rowsize'];
    }
    return '';
  }

  public getInputType(t: string) {
    if (t === 'date') {
      return t;
    } else if (t === 'number' || t === 'decimal') {
      return 'number';
    }
    if (t === 'text') {
      return 'text';
    }
    if (t === 'date') {
      return t;
    }
    if (t === 'time') {
      return t;
    }
    if (t === 'file') {
      return t;
    } else {
      return 'text';
    }
  }

  // Map your button names to Material Color Palettes
  getMaterialColor(name: string): string {
    switch (name) {
      case 'save':
        return 'primary'; // Blue
      case 'delete':
        return 'warn'; // Red
      case 'cancel':
        return 'warn'; // warn/Default
      default:
        return 'primary';
    }
  }

  // Map FontAwesome icons to Material Icons
  getMaterialIcon(name: string): string {
    const iconMap: { [key: string]: string } = {
      save: 'save',
      cancel: 'close',
      delete: 'delete',
      list: 'list',
      new: 'add',
      custom: 'settings',
    };
    return iconMap[name] || 'settings';
  }
  getButtonClass(buttonKey: string) {
    const button_class: { [key: string]: string } = {
      save: 'btn btn-sm btn-outline-primary ms-2',
      cancel: 'btn btn-sm btn-outline-primary ms-2',
      delete: 'btn btn-sm btn-outline-primary ms-2',
      list: 'btn btn-sm btn-outline-primary ms-2',
      new: 'btn btn-sm btn-outline-primary ms-2',
    };
    return button_class[buttonKey] || 'btn btn-sm btn-outline-primary ms-2';
  }

  getButtonIcon(buttonKey: string): string {
    const icons: { [key: string]: string } = {
      save: 'fas fa-save',
      cancel: 'fas fa-times',
      delete: 'bx bxs-trash',
      list: 'fas fa-list',
      new: 'fa fa-plus',
    };
    return icons[buttonKey] || 'fa fa-invisible';
  }

  // Method to get the button label based on the key
  getButtonLabel(buttonKey: string): string {
    const labels: { [key: string]: string } = {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      list: 'List',
      new: 'New',
    };
    return labels[buttonKey] || 'Custom';
  }

  getItemClasses(field: any): string {
    let cols = 12;
    if (field.colsize) {
      cols = 12 / field.colsize;
    }
    return `col-${cols} ${field.rows === 2 ? 'row-span-2' : ''}`;
  }

  getGroupsField(label: any) {
    return this.fields.filter((field: any) => field?.group == label);
  }

  getFieldNotIngroup() {
    if (!this.fields || !Array.isArray(this.fields)) {
      return [];
    }
    // return this.fields.filter(
    //   (field: any) => !field.group && field.group == null
    // );

    return this.fields.filter((field: any) => {
      return !field.group || field.group === null || field.group === '';
    });
  }
}
